/**
 *
 * This is a JavaScript BlackMostros Template.
 *
 * @source: http://www.pronia.es/templates/black-mostros
 *
 * @licstart  The following is the entire license notice for the
 *  JavaScript code in this page.
 *
 * Copyright (C) 2014  David Lemos González
 *
 *
 * The JavaScript code in this page is free software: you can
 * redistribute it and/or modify it under the terms of the GNU
 * General Public License (GNU GPL) as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option)
 * any later version.  The code is distributed WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE.  See the GNU GPL for more details.
 *
 * As additional permission under GNU GPL version 3 section 7, you
 * may distribute non-source (e.g., minimized or compacted) forms of
 * that code without the copy of the GNU GPL normally required by
 * section 4, provided you include this license notice and a URL
 * through which recipients can access the Corresponding Source.
 *
 * @licend  The above is the entire license notice
 * for the JavaScript code in this page.
 *
 */

// export default obj => {
//   return new Promise((resolve, reject) => {
//     resolve(ShowBase());
//     reject('bad');
//     });
//   };


let ShowBase = (function(){
  let _show_class = 'collapse',
    mpublic = {};

  function _show_element(ele){
    /*
     * show element
     * if element have class collapse, remove it
     *
     */

    function _hide_show_one(ele){
      // ~ console.log('hide_show', ele);
      if (ele.classList.contains(_show_class)) {
        ele.classList.remove(_show_class);
      }
      // ~ ele.display = "inherit";

      /* jquery
      if (ele.hasClass('collapse')) {
        ele.removeClass('collapse');
      }
      ele.css("display", "inherit");
      */
      //~ ele.style.display = 'inherit';
    }

    if (ele instanceof HTMLCollection) {
      [].forEach.call(ele, function(_ele, i) {
        _hide_show_one(_ele);
      });
    } else {
      _hide_show_one(ele);
    }
    return true;
  }
  mpublic.show_element = _show_element;

  function _hide_element(ele){
    // hide element
    function _hide_show_one(ele){
      ele.classList.toggle(_show_class);
      // ~ console.log('hide_show', ele);
      // ~ ele.style.display = "none";
      // ~ ele.css("display", "none");
      //~ ele.style.display = 'none';
    }

    if (ele instanceof HTMLCollection) {
      [].forEach.call(ele, function(_ele, i) {
        _hide_show_one(_ele);
      });
    } else {
      _hide_show_one(ele);
    }
    return false;
  }
  mpublic.hide_element = _hide_element;

  return mpublic;

});

export {
  ShowBase,
  };
